module.exports = __webpack_public_path__ + "static/img/ckturistando-RSvKa3Jg3Z8.8831227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/ckturistando-RSvKa3Jg3Z8.jpg
// module id = KxxD
// module chunks = 1